import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr';
import { SubmissionError } from 'redux-form';
import { hideModal, MODAL_FORM_TEACHER } from '../../modules/modals';
import { updateProfile } from '../../modules/profile';

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

export function getTeachers() {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/teacher/list');
      if(data.errcode == 200) {
        dispatch({type: 'GET_TEACHERS', data: data.payload})
        return data.payload;
      } else {
        throw new Error('Bag request')
      }
    } catch (error) {
    }
  }
}


export function createTeacher(body) {
  if(body.permission){
    body.permission = JSON.stringify(body.permission);
  }
  return axios.post('/api/teacher/create', body).then(({data}) => {
    if(data.errcode == 200) {
      return {status: true, data: data.payload};
    } else {
      const err_field = {};
      if(data.error){
        Object.keys(data.error).forEach(key => {
          if(data.error[key]){
            err_field[key] = data.error[key][0];
          }
        })
      }
      return {status: false, error: err_field };
    }
  })
}
export function updateTeacherData(body) {
  if(body.permission){
    body.permission = JSON.stringify(body.permission);
  }
  return axios.post('/api/teacher/update', body).then(({data}) => {
    if(data.errcode == 200) {
      return {status: true, data: data.payload};
    } else {
      const err_field = {};
      if(data.error){
        Object.keys(data.error).forEach(key => {
          if(data.error[key]){
            err_field[key] = data.error[key][0];
          }
        })
      }
      return {status: false, error: err_field };
    }
  })
}
export function resetPswTeacher(body) {
  if(body.permission){
    body.permission = JSON.stringify(body.permission);
  }
  return axios.post('/api/teacher/reset', body).then(({data}) => {
    if(data.errcode == 200) {
      return {status: true, data: data.payload};
    } else {
      const err_field = {};
      if(data.error){
        Object.keys(data.error).forEach(key => {
          if(data.error[key]){
            err_field[key] = data.error[key][0];
          }
        })
      }
      return {status: false, error: err_field };
    }
  })
}

export function statusTeacher(body) {
  return (dispatch) => {
    return axios.post('/api/teacher/status', body).then(({data}) => {
      if(data.errcode == 200) {
        dispatch({type: 'UPDATE_TEACHER', data: data.payload})
        return {status: true, data: data.payload};
      } else {
        const err_field = {};
        if(data.error){
          Object.keys(data.error).forEach(key => {
            if(data.error[key]){
              err_field[key] = data.error[key][0];
            }
          })
        }
        return {status: false, error: err_field };
      }
    })
  }
}

export function updateTeacher(data) {
  return async (dispatch) => {
    try {
      dispatch({type: 'UPDATE_TEACHER', data})
      return true;
    } catch (error) {
    }
  }
}


export function renameOrganisation(body) {
  return (dispatch) => {
    return axios.post('/api/teacher/rename-organisation', body).then(({data}) => {
      if(data.errcode == 200) {
        dispatch(updateProfile(data.payload));
        return {status: true, data: data.payload};
      } else {
        
        return {status: false};
      }
    })
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/UserOrganisation/actions.js